import { Link } from "react-router-dom";
import {
  UtensilsCrossed,
  Hotel,
  HeartPulse,
  Warehouse,
  GraduationCap,
  ShoppingBag,
  Factory,
  Truck,
  Building2,
  Trophy,
  Landmark,
  Sparkles,
  Church,
  Star,
} from "lucide-react";

const IndustriesSection = () => {
  const industries = [
    {
      name: "Food & Beverage",
      Icon: UtensilsCrossed,
      description: "BellaBot Pro, KettyBot Pro, HolaBot & CC1 Pro — plus AI voice agents for reservations and follow-up.",
      link: "/restaurants",
    },
    {
      name: "Hospitality",
      Icon: Hotel,
      description: "KettyBot Pro, FlashBot Max & CC1 Pro for guest service, delivery and spotless floors.",
      link: "/hotels",
    },
    {
      name: "Health Care",
      Icon: HeartPulse,
      description: "CC1 Pro, FlashBot Max, BG1 & MT1 Series for sanitation consistency and internal transport.",
      link: "/healthcare",
    },
    {
      name: "Warehouses & Logistics",
      Icon: Warehouse,
      description: "T300, T600, MT1 Max & D5 for heavy transport, cleaning coverage and operational workflows.",
      link: "/warehouses",
    },
    {
      name: "Retail",
      Icon: ShoppingBag,
      description: "KettyBot Pro & CC1 Pro for guided service, marketing displays and consistent floor care.",
      link: "/robots",
    },
    {
      name: "Manufacturing",
      Icon: Factory,
      description: "MT1 Max, T600 & SH1 to reduce repetitive labor and support continuous operations.",
      link: "/robots",
    },
    {
      name: "Industrial Facilities",
      Icon: Building2,
      description: "Heavy-duty cleaning and material transport built for large, complex environments.",
      link: "/robots",
    },
    {
      name: "Transportation",
      Icon: Truck,
      description: "Autonomous cleaning and delivery solutions for terminals, depots and transit hubs.",
      link: "/robots",
    },
    {
      name: "Entertainment & Sports",
      Icon: Trophy,
      description: "KettyBot Pro & HolaBot for venues, arenas and high-traffic guest experiences.",
      link: "/robots",
    },
    {
      name: "Real Estate & Property",
      Icon: Landmark,
      description: "CC1 Pro, MT1 Series & SH1 for property management and large facility upkeep.",
      link: "/robots",
    },
    {
      name: "Education",
      Icon: GraduationCap,
      description: "Autonomous cleaning for schools, campuses and university facilities.",
      link: "/education",
    },
    {
      name: "Commercial Cleaning",
      Icon: Sparkles,
      description: "CC1 Pro, MT1 Max, BG1 & SH1 to deliver consistent, scalable cleaning programs.",
      link: "/robots",
    },
    {
      name: "Church Automation Solutions",
      Icon: Church,
      description: "AI Receptionists, 24/7 Prayer Lines, Visitor Follow-Up, Prayer Request Management, Appointment Scheduling, Member Communications & PUDU Robotics for Cleaner Facilities.",
      link: "/solutions/churches",
    },
  ];

  return (
    <section className="py-16">
      <div className="text-center mb-12">
        <h2 className="font-orbitron font-bold text-4xl md:text-5xl mb-4">
          Industries We <span className="text-primary">Serve</span>
        </h2>
        <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
          Tailored AI automation and robotics solutions for real-world operational challenges.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        {industries.map(({ name, Icon, description, link }) => (
          <Link
            key={name}
            to={link}
            className="border border-[hsl(var(--line))] glass-effect p-6 rounded-xl hover:bg-white/5 transition-all duration-300 hover:scale-[1.02] hover:shadow-xl hover:border-primary/40 group"
          >
            <div className="w-12 h-12 rounded-lg bg-primary/10 border border-primary/20 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors">
              <Icon className="w-6 h-6 text-primary" strokeWidth={1.5} />
            </div>
            <h3 className="font-orbitron font-bold text-xl mb-2 group-hover:text-primary transition-colors">
              {name}
            </h3>
            <p className="text-sm text-muted-foreground mb-4">{description}</p>
            <span className="text-primary font-semibold text-sm">Learn more →</span>
          </Link>
        ))}

        <Link
          to="/case-studies"
          className="border border-secondary/40 bg-secondary/5 p-6 rounded-xl hover:bg-secondary/10 transition-all duration-300 hover:scale-[1.02] hover:shadow-xl group flex flex-col justify-center items-center text-center"
        >
          <div className="w-12 h-12 rounded-lg bg-secondary/10 border border-secondary/30 flex items-center justify-center mb-4">
            <Star className="w-6 h-6 text-secondary" strokeWidth={1.5} />
          </div>
          <h3 className="font-orbitron font-bold text-xl mb-2 group-hover:text-secondary transition-colors">
            Operational Impact Stories
          </h3>
          <p className="text-sm text-muted-foreground mb-4">
            See how AI + robotics support real teams across industries.
          </p>
          <span className="text-secondary font-semibold text-sm">View case studies →</span>
        </Link>
      </div>
    </section>
  );
};

export default IndustriesSection;
